import useTranslation from '../../hooks/useTranslation';
import FieldRow from '../FieldRow';

import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const TankVolumeSection: FunctionComponent<Props> = ({ tankVolumeSummary, testId = TEST_ID }) => {
    const translations = useTranslation();

    return (
        <VerticalContainer className={styles.tankVolumeSection} testId={testId}>
            <Wrapper className={styles.sectionHeader}>{translations.TANK_VOLUME}</Wrapper>

            <FieldRow label={translations.MIX_TANK} value={`${tankVolumeSummary.mixTankGal}`} />

            <FieldRow label={translations.APP_TANK} value={`${tankVolumeSummary.appTankGal}`} />

            <FieldRow label={translations.CARRIER_TYPE} value={tankVolumeSummary.carrierType} />

            <FieldRow
                label={translations.CARRIER_RATE}
                value={`${tankVolumeSummary.carrierRateGalPerAc}`}
            />

            <FieldRow
                label={translations.TOTAL_SPRAY_VOLUME}
                value={`${tankVolumeSummary.totalSprayVolumeGal}`}
            />

            <FieldRow label={translations.BATCHES} value={`${tankVolumeSummary.batches}`} />

            <FieldRow
                label={translations.ACRES_PER_TANK}
                value={`${tankVolumeSummary.acresPerTank}`}
            />
        </VerticalContainer>
    );
};

export default TankVolumeSection;
